/**
 * @see https://developer.mozilla.org/es/docs/Web/API/KeyboardEvent/key/Key_Values
 */
export const escapeKeyCode = 'Escape';

export const mainLayoutId = 'main-layout';

export const baseUrl = process.env.REACT_APP_BASE_URL;

export const analyticsId = process.env.REACT_APP_GA_ID;

export const allowCookiesStorageKey = 'allowCookies';

export const networkTimeout = 5000;

export const httpStatusCreated = 201;
